<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    @change="setRegionalId"
    :label="$t('regionalManager')"
    item-text="name"
    item-value="id"
    :prepend-icon="parent ? '' : 'mdi-account-tie orange--text'"
    dense
    filled
    solo-inverted
    clearable
    hide-details
    @click:clear="clearable()"
    class="color-icon-regional"
  >
    <!-- UI com o ICON WEB caso o Regional seja Online (afiliado) -->
    <template v-slot:item="data">
      {{ data.item.name }}
      <v-icon small color="primary" class="mx-2" v-if="data.item.comissao">
        mdi-web
      </v-icon>
    </template>
  </v-autocomplete>
</template>
<script>
// import { validate } from "@/util/validate";
export default {
  name: "components-common-filter-autocomplete-regionals",
  props: {
    parent: {
      type: String
    }
  },
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    // selectRules: [validate.selectRequired],
  }),
  computed: {
    enableAutocompleteRegionals() {
      return this.$store.state.filters.autocompleteRegionals.enable;
    },
  },
  mounted() {
    // Setup
    let level = localStorage.getItem("level");
    if (level === "administrator" || level === "collaborator") {
      this.getRegionalsList();
    }
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;
      // request
      this.getRegionalsList();
    },

    // If params and query Id_Regional Set Select:
    $route: function() {
      let select;

      if (this.$route.params.id_regional) {
        select = this.items.filter(
          (item) => item.id == this.$route.params.id_regional
        );
      }

      if (this.$route.query.id_regional) {
        select = this.items.filter(
          (item) => item.id == this.$route.query.id_regional
        );
      }

      // No exist query or params id_regionla ? return.
      if (!this.$route.params.id_regional && !this.$route.query.id_regional) {
        return;
      }

      if (select[0] == undefined) return;
      this.select = select[0];
      this.setRegionalId(this.select.id);
    },
  },
  methods: {
    clearable() {
      this.$store.commit("setRegionalId", "");
    },
    setRegionalId(regionalId) {
      this.$store.commit("setRegionalId", regionalId ? regionalId : "");
    },
    async getRegionalsList() {
      this.isLoading = true;
      try {
        const user_data = JSON.parse(localStorage.getItem("user_data"));

        const endpoint = user_data.isCollaborator
          ? "/colab/regionals/list"
          : "administrator/regionals/list";

        const response = await this.$request.post(endpoint, { status: 1 });

        if (response.length == 0) {
          this.items = [];
          return;
        }

        this.items = response.dados.map((item) => ({
          name: `${item.name_regional} (${item.id})`,
          id: item.id,
          comissao: item.comissao_online ? item.comissao_online : "",
        }));

        this.$store.commit("listUsersRegionals", this.items);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
